import { OrderStatusEnum } from '@shared/enums';

export const orderStatusNames: Record<OrderStatusEnum, string> = {
    [OrderStatusEnum.ALL]: 'status.all',
    [OrderStatusEnum.ACTION_REQUIRED]: 'order.status.actionRequired',
    [OrderStatusEnum.CANCELED]: 'order.status.canceled',
    [OrderStatusEnum.COMPLETED]: 'order.status.completed',
    [OrderStatusEnum.INCOMPLETE]: 'order.status.incomplete',
    [OrderStatusEnum.IN_PROGRESS]: 'order.status.inProgress',
    [OrderStatusEnum.ORDER_SUBMITTED]: 'order.status.orderSubmitted',
    [OrderStatusEnum.PARTIALLY_COMPLETED]: 'order.status.partiallyCompleted',
    [OrderStatusEnum.RECEIVED]: 'order.status.received',
    [OrderStatusEnum.CANCELED_FROM_LIMS]: 'order.status.canceled',
};

export const orderStatusNamesTooltips: Record<OrderStatusEnum, string> = {
    [OrderStatusEnum.ALL]: '',
    [OrderStatusEnum.ACTION_REQUIRED]: 'order.status.actionRequired.tooltip',
    [OrderStatusEnum.CANCELED]: 'order.status.canceled.tooltip',
    [OrderStatusEnum.COMPLETED]: 'order.status.completed.tooltip',
    [OrderStatusEnum.INCOMPLETE]: 'order.status.incomplete.tooltip',
    [OrderStatusEnum.IN_PROGRESS]: 'order.status.inProgress.tooltip',
    [OrderStatusEnum.ORDER_SUBMITTED]: 'order.status.orderSubmitted.tooltip',
    [OrderStatusEnum.PARTIALLY_COMPLETED]: 'order.status.partiallyCompleted.tooltip',
    [OrderStatusEnum.RECEIVED]: 'order.status.received.tooltip',
    [OrderStatusEnum.CANCELED_FROM_LIMS]: 'order.status.canceled.tooltip',
};
